<template>
  <section>
    <Article
      v-for="(article, index) in list"
      v-bind:key="article.path"
      v-bind:article="article"
      v-bind:index="index"
      @view-article="$emit('view-article', $event)"
    />
  </section>
</template>

<script setup lang="ts">
import { isNil } from 'lodash-es'
import Article from './Article.vue'
import { getQueryParams } from './utils'

const props = defineProps({
  limit: {
    type: Number,
    default: 0,
  },
  surround: {
    type: String,
    default: ''
  }
})

const { data } = await useAsyncData('repost-feed-list', async () => {
  // 获取当前文章
  const currentArticle = await queryCollection('articles')
    .path(props.surround)
    .first()
  
  if (!currentArticle) {
    return []
  }

  // 获取所有文章
  const all = await queryCollection('articles').all()
  const now = new Date()
  
  // 过滤已发布的文章
  const allArticles = all.filter((article: any) => {
    if (!article.schedule) return true
    const scheduleDate = new Date(article.schedule)
    return scheduleDate <= now
  })
  
  // 找到当前文章的索引
  const currentIndex = allArticles.findIndex((article: any) => article.path === currentArticle.path)
  
  if (currentIndex === -1) {
    return []
  }
  
  // 获取前后的文章
  const result = []
  const beforeCount = Math.min(props.limit, currentIndex)
  const afterCount = Math.min(props.limit, allArticles.length - currentIndex - 1)
  
  // 获取前面的文章
  for (let i = beforeCount; i > 0; i--) {
    result.push(allArticles[currentIndex - i])
  }
  
  // 获取后面的文章
  for (let i = 1; i <= afterCount && result.length < props.limit; i++) {
    result.push(allArticles[currentIndex + i])
  }
  
  return result.slice(0, 3)
})

const list = computed(() => data.value || [])
</script>

<style scoped>
</style>
